export default __webpack_public_path__ + "static/banner-how-car-ownership-has-shifted-gears-191355c2413f8ba7c8a4d104b34606ac.jpg";